import { AuthGate } from "@/components/auth/auth-gate";
import SignInEmailPassword from "@/components/routes/auth/sign-in/sign-in-email-password";
import { Route, Routes, Outlet, Navigate } from "react-router-dom";
import { useUserData } from "@nhost/react";
import Navbar from "./appnavigate/NavBar2";
import AdminPage from "./components/routes/app/AdminPage";
import Profile from "@/components/routes/app/profile";
import HomeReglementation from "./components/routes/app/homereglementation";
import 'bootstrap/dist/css/bootstrap.min.css';
import ResetPasswordPage from "./components/routes/app/ResetPasswordPage";
import DownloadPage from "./components/routes/app/DownloadPage";
import ForgotPassword from "./components/routes/auth/forgot-password";

// Layout for the protected routes
function ProtectedRoutes() {
  return (
    <>
      <Navbar /> {/* Navbar will be shown in all protected routes */}
      <Outlet /> {/* This will render the child routes */}
    </>
  );
}

function App() {
  const user = useUserData();
  const isAdmin = user?.roles?.includes("UserAdmin");

  return (
    <Routes>
      {/* Protected routes (only accessible when authenticated) */}
      <Route
        path="/"
        element={
          <AuthGate>
            <ProtectedRoutes /> {/* Render Navbar and child routes */}
          </AuthGate>
        }
      >
        {/* Quand l'URL est vide "/", afficher HomeReglementation */}
        <Route index element={<Navigate to="/home" replace />} />

        {/* Routes protégées */}
        <Route path="home" element={<HomeReglementation />} />
        <Route path="profil" element={<Profile />} />
        {isAdmin && <Route path="administration" element={<AdminPage />} />}
      </Route>

      {/* Authentication routes */}
      <Route path="/sign-in">
        <Route index element={<SignInEmailPassword />} />
      </Route>
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/DownloadPage" element={<DownloadPage />} />
    </Routes>
  );
}

export default App;
